export const currencyMask = (rawValue?: string | number) => {
  if (!rawValue) return;
  if (typeof rawValue === 'number') rawValue = rawValue.toString();
  rawValue = rawValue.replace(/\D/g, '');

  const int = parseInt(rawValue, 10);
  if (isNaN(int)) return '';
  rawValue = int.toString();
  rawValue = rawValue.replace(/(\d)(\d{11})$/, '$1.$2');
  rawValue = rawValue.replace(/(\d)(\d{8})$/, '$1.$2');
  rawValue = rawValue.replace(/(\d)(\d{5})$/, '$1.$2');
  if (int < 10) {
    rawValue = rawValue.replace(/(\d)(\d{0,2})$/, '0,0$1');
  } else if (int < 100) {
    rawValue = rawValue.replace(/(\d)(\d{0,2})$/, '0,$1$2');
  } else {
    rawValue = rawValue.replace(/(\d)(\d{2})$/, '$1,$2');
  }

  const finalValue = rawValue.length === 0 ? '' : 'R$ ' + rawValue;

  return finalValue;
};
